import { useEffect, useState } from 'react'
import { fg } from '../copyFeatGrowth'
import { dismissInstall, installDismissed, installKind, onInstallPrompt, promptInstall } from '../lib/install'
import { Close, Share } from '../ui/icons'
import { buttonClass } from '../ui/styles'

/**
 * Add to home screen (R-59): a one-time hint. iPhone: Share, then Add to Home Screen (Safari has no prompt). Android:
 * our button opens Chrome's own install prompt. Hidden once installed, dismissed or in another browser. The caller shows
 * it after a first calendar add or save (never in the first run).
 */
export function InstallHint() {
  const [kind, setKind] = useState(installKind)
  const [gone, setGone] = useState(installDismissed)
  useEffect(() => onInstallPrompt(() => setKind(installKind())), [])
  if (gone || !kind) return null
  const close = () => { dismissInstall(); setGone(true) }
  return (
    <section data-review-id="install-hint" aria-labelledby="install-title" className="relative mt-5 border border-line bg-surface p-5 pr-14">
      <button type="button" onClick={close} aria-label={fg('fg.install_dismiss')}
        className="press absolute top-2 right-2 inline-flex size-11 items-center justify-center rounded-[12px] text-ink-2 hover:bg-sunk">
        <Close size={18} />
      </button>
      <h2 id="install-title" className="t-headline text-ink">{fg('fg.install_title')}</h2>
      {kind === 'ios' ? (
        <p className="t-body mt-2 text-ink-2">
          <Share size={18} className="mr-1 inline align-[-3px] text-ink" />{fg('fg.install_ios')}
        </p>
      ) : (
        <>
          <p className="t-body mt-2 text-ink-2">{fg('fg.install_android')}</p>
          <button type="button" data-review-id="install-cta" onClick={() => { void promptInstall(); setGone(true) }} className={buttonClass('primary', 'md', 'mt-3')}>{fg('fg.install_cta')}</button>
        </>
      )}
      <button type="button" onClick={close} className="press mt-1 inline-flex min-h-11 items-center text-[15px] font-semibold text-ink-2 underline underline-offset-4">{fg('fg.install_dismiss')}</button>
    </section>
  )
}
